import type { VehicleType } from '@/state/types';
import { VEHICLE_SPECS } from '@/data/vehicles';

export type SilhouetteCategory = 'fire' | 'ems' | 'police' | 'special';

/**
 * "Special" = command/transport/escort/utility — anything that isn't a
 * dedicated extinguisher or ambulance. Block B vocabulary.
 */
const SPECIAL_TYPES = new Set<VehicleType>(['ELW', 'MTW', 'PKW', 'SW', 'GW', 'RW']);

export function silhouetteCategoryFor(type: VehicleType): SilhouetteCategory {
  const cat = VEHICLE_SPECS[type].category;
  if (cat === 'police') return 'police';
  if (SPECIAL_TYPES.has(type)) return 'special';
  return cat === 'fire' ? 'fire' : 'ems';
}
